<template>
  <div class="loading-mask" v-if="loading">
    <div class="loading-spinner"></div>
  </div>
  <div class="front-layout" :style="{ backgroundColor: '#FFF' }">
    <!-- 左侧侧边栏 -->
    <div class="sidebar">
      <div class="logo-container" :style="{ color: '#C1272D' }">
        <img
          class="logo-img"
          v-if="titles === '样衣星球'"
          :src="imgur"
          alt="示例图片"
        />
        <img class="logo-img" v-else :src="imgurs" alt="示例图片" />
      </div>
      <el-menu
        class="sidebar-menu"
        text-color="#333"
        active-text-color="#C1272D"
        router
        :default-active="$store.getters.frontMenuActiveIndex"
      >
        <el-menu-item index="/about">
          <img
            src="../assets/1.jpg"
            style="width: 23px; height: 18px; margin-right: 9px"
            alt=""
          />
          <span style="font-size: 18px">样 衣</span>
        </el-menu-item>
        <el-menu-item index="/home" @click.capture="handleAuthMenuClick">
          <img
            src="../assets/2.jpg"
            style="width: 23px; height: 18px; margin-right: 9px"
            alt=""
          /><span
            style="font-size: 18px; display: inline-block; margin-right: -14px"
            >供应商</span
          >
        </el-menu-item>
        <el-menu-item index="/usermanage" @click.capture="handleAuthMenuClick">
          <img
            src="../assets/3.jpg"
            style="width: 23px; height: 18px; margin-right: 9px"
            alt=""
          /><span style="font-size: 18px">关 注</span>
        </el-menu-item>
        <el-menu-item
          class="login-menu-item"
          :style="{
            backgroundColor: '#F8B42E',
            color: 'black',
            fontSize: '28px',
            height: '68px',
            borderRadius: '12px',
            width: '241px',
            marginTop: '2px',
            lineHeight: '68px',
            fontWeight: '700',
          }"
          @click="openLoginDialog"
          v-if="!hasValidToken"
        >
          登 录
        </el-menu-item>
        <el-menu-item
          index="/my"
          v-if="hasValidToken"
          :class="
            $store.state.frontUserInfo.belongId !==
            $store.state.frontUserInfo.id
              ? 'dis'
              : ''
          "
          style="margin-top: 2px; position: relative"
        >
          <img
            :class="
              $store.state.frontUserInfo.belongId !==
              $store.state.frontUserInfo.id
                ? 'imgs'
                : ''
            "
            :src="showUserAvatar"
            style="
              width: 40px;
              height: 40px;
              border-radius: 50%;
              margin-right: 9px;
              margin-top: 22px;
            "
          />
          <div
            v-if="
              $store.state.frontUserInfo.belongId !==
              $store.state.frontUserInfo.id
            "
          >
            <p style="font-size: 18px; height: 20px; margin-top: 6px">
              {{ belongNickName }}
            </p>
            <p style="font-size: 18px; height: 20px; margin-top: 6px">子账号</p>
            <p style="font-size: 18px; height: 20px; margin-top: 6px">
              {{ showUsername }}
            </p>
          </div>
          <span
            v-else
            style="
              font-size: 18px;
              display: inline-block;
              margin-right: 14px;
              margin-top: 30px;
            "
            >{{ showUsername }}</span
          >
        </el-menu-item>
      </el-menu>
      <div class="icp-record">
        <div
          class="about-btn"
          style="margin: 10px 20px; cursor: pointer"
          @click="profile()"
        >
          <span style="font-size: 20px">关于我们</span>
        </div>
        <div
          v-if="hasValidToken"
          class="more-btn"
          @click="isMoreDialogOpen = !isMoreDialogOpen"
          style="margin: 10px 20px; cursor: pointer"
        >
          <span style="font-size: 18px">更多</span>
        </div>
        粤ICP备2025515323号-1
      </div>
    </div>
    <!-- 右侧主内容区 -->
    <div class="main-content">
      <div class="top-right-publish" v-if="hasValidToken">
        <el-button class="publish-btn" @click="openPublishPage">
          +样衣发布
        </el-button>
      </div>

      <!--商品列表页用keep-alive缓存组件-->
      <router-view v-slot="{ Component }">
        <keep-alive include="FrontProductList">
          <component :is="Component" />
        </keep-alive>
      </router-view>

      <LoginDialog
        v-model="isLoginDialogOpen"
        :basic-auth="basicAuth"
        @login-success="handleLoginSuccess"
      />
      <div v-if="hasValidToken && isMoreDialogOpen" class="native-popup">
        <div class="popup-content">
          <div
            class="security-btn"
            @click="openAccountSecurityDialog"
            v-if="
              $store.state.frontUserInfo.belongId ==
              $store.state.frontUserInfo.id
            "
          >
            账号与安全
          </div>
          <el-popconfirm
            title="确认退出吗?"
            confirmButtonText="确认"
            cancelButtonText="取消"
            @confirm="handleFrontLogout"
            @cancel="isMoreDialogOpen = false"
          >
            <template #reference>
              <div class="logout-btn">退出登录</div>
            </template>
          </el-popconfirm>
        </div>
        <div class="popup-mask" @click="isMoreDialogOpen = false"></div>
      </div>
      <!-- 账号与安全弹窗 -->
      <el-dialog
        title="账号与安全"
        v-model="accountSecurityVisible"
        width="520px"
        center
        :close-on-click-modal="false"
        @close="clearPollTimer"
      >
        <!-- 手机号（解绑/设置）【修改这里】 -->
        <div class="security-item">
          <span class="label">手机号</span>
          <span class="value">
            <template v-if="accountInfo.phone">
              <el-popconfirm
                title="确定要解绑手机号吗"
                confirm-button-text="确认解绑"
                cancel-button-text="取消"
                @confirm="delpt('phone')"
              >
                <template #reference>
                  <span style="color: #ffae00; cursor: pointer"
                    >{{ accountInfo.phone }}（点击解绑）</span
                  >
                </template>
              </el-popconfirm>
            </template>
            <!-- 无手机号，直接输入框，失焦提交 -->
            <el-input
              v-else
              v-model="bindPhoneVal"
              placeholder="请输入手机号"
              type="number"
              maxlength="11"
              style="width: 220px"
              @blur="submitPhoneBind"
            />
          </span>
        </div>
        <div class="security-item">
          <span class="label">登录密码</span>
          <span class="value" style="cursor: pointer" @click="openPwdDialog"
            >修改密码
          </span>
        </div>
        <!-- 微信账号 -->
        <div class="security-item">
          <span class="label" style="margin-right: 24px"
            >微信账号 <span>首次非微信扫码，请绑定微信号</span>
          </span>
          <span class="value">
            <template v-if="accountInfo.wechat">
              <el-popconfirm
                title="确定要解绑微信账号吗"
                confirm-button-text="确认解绑"
                cancel-button-text="取消"
                @confirm="delpt('wechat')"
              >
                <template #reference>
                  <span style="color: #ffae00; cursor: pointer"
                    >{{ accountInfo.wxname }}（点击解绑）</span
                  >
                </template>
              </el-popconfirm>
            </template>
            <span v-else @click="bound('wechat')" style="cursor: pointer"
              >未绑定</span
            >
          </span>
        </div>
        <!-- 抖音账号 -->
        <div class="security-item">
          <span class="label">抖音账号</span>
          <span class="value">
            <template v-if="accountInfo.douyin">
              <el-popconfirm
                title="确定要解绑抖音账号吗"
                confirm-button-text="确认解绑"
                cancel-button-text="取消"
                @confirm="delpt('douyin')"
              >
                <template #reference>
                  <span style="color: #ffae00; cursor: pointer"
                    >{{ accountInfo.dyname }}（点击解绑）</span
                  >
                </template>
              </el-popconfirm>
            </template>
            <span v-else @click="bound('douyin')" style="cursor: pointer"
              >未绑定</span
            >
          </span>
        </div>
        <!-- 支付宝账号 -->
        <div class="security-item">
          <span class="label">支付宝账号</span>
          <span class="value">
            <template v-if="accountInfo.alipay">
              <el-popconfirm
                title="确定要解绑支付宝账号吗"
                confirm-button-text="确认解绑"
                cancel-button-text="取消"
                @confirm="delpt('alipay')"
              >
                <template #reference>
                  <span style="color: #ffae00; cursor: pointer"
                    >{{ accountInfo.zfbname }}（点击解绑）</span
                  >
                </template>
              </el-popconfirm>
            </template>
            <span v-else @click="bound('alipay')" style="cursor: pointer"
              >未绑定</span
            >
          </span>
        </div>
      </el-dialog>
      <!-- ========= 删除【设置手机号弹窗】整块 ========= -->
      <!-- 修改密码弹窗 -->
      <el-dialog
        title="修改登录密码"
        v-model="pwdDialogVisible"
        center
        width="460px"
        :close-on-click-modal="false"
      >
        <el-form ref="pwdFormRef" :model="pwdForm" label-width="90px">
          <el-form-item label="旧密码" prop="oldPassword">
            <el-input
              v-model="pwdForm.oldPassword"
              show-password
              placeholder="请输入旧密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input
              v-model="pwdForm.newPassword"
              show-password
              placeholder="请输入新密码"
            ></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button
            class="publish-btn"
            style="width: 60px"
            @click="pwdDialogVisible = false"
            >取消</el-button
          >
          <el-button class="publish-btn" style="width: 60px" @click="submitPwd"
            >确定</el-button
          >
        </template>
      </el-dialog>
      <!-- iframe扫码授权弹窗-->
      <el-dialog
        title="账号绑定扫码"
        v-model="iframeAuthVisible"
        width="800px"
        :close-on-click-modal="false"
        @close="handleIframeDialogClose"
      >
        <iframe
          v-if="authIframeUrl"
          ref="authIframe"
          :src="authIframeUrl"
          style="width: 100%; height: 550px; border: none"
          frameborder="0"
          sandbox="allow-scripts allow-same-origin allow-popups"
          allow="fullscreen"
          allowtransparency="true"
          scrolling="no"
        ></iframe>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import LoginDialog from "@/components/LoginDialog.vue";
import url from "../views/admins/123.png";
import urls from "../views/admins/456.png";
import {
  connectLoginStatusSocket,
  closeLoginStatusSocket,
} from "@/utils/loginStatusSocket";
export default {
  name: "FrontLayout",
  components: {
    LoginDialog,
  },
  data() {
    return {
      titles: "",
      imgur: url,
      imgurs: urls,
      basicAuth: {
        clientId: "yyyhao-front",
        clientSecret: "guoyin",
      },
      loading: false,
      isLoginDialogOpen: false,
      isMoreDialogOpen: false,
      version: 0,
      defaultAvatar:
        "https://pic1.zhimg.com/50/v2-6afa72220d29f045c15217aa6b275808_720w.jpg?source=1940ef5c",
      accountSecurityVisible: false,
      accountInfo: {
        phone: "",
        wechat: false,
        wxname: "",
        dyname: "",
        zfbname: "",
        douyin: false,
        alipay: false,
      },
      iframeAuthVisible: false,
      authIframeUrl: "",
      pollTimer: null,
      pollMaxCount: 30,
      pollCurrentCount: 0,
      // ========= 删除 phoneDialogVisible、upphoneForm =========
      // 新增：手机号绑定输入框变量
      bindPhoneVal: "",
      pwdDialogVisible: false,
      pwdForm: {
        oldPassword: "",
        newPassword: "",
      },
    };
  },
  watch: {
    $route(to) {
      this.$store.commit("SET_FRONT_MENU_ACTIVE", to.path);
    },
    iframeAuthVisible(val) {
      if (!val) {
        this.clearPollTimer();
        this.authIframeUrl = "";
      }
    },
    // 打开账号安全弹窗时，初始化手机号输入框
    accountSecurityVisible(val) {
      if (val && !this.accountInfo.phone) {
        this.bindPhoneVal = "";
      }
    },
  },
  computed: {
    hasValidToken() {
      return this.$store.getters.isFrontLogin;
    },
    frontUserInfo() {
      return this.$store.getters.frontUserInfo;
    },
    showUsername() {
      return this.frontUserInfo.nickName || "用户名";
    },
    belongNickName() {
      return this.frontUserInfo.belongNickName || "主账号";
    },
    showUserAvatar() {
      return (
        this.getFullImgUrl(this.frontUserInfo.avatarUrl) || this.defaultAvatar
      );
    },
  },
  beforeUnmount() {
    this.clearPollTimer();
  },
  mounted() {
    this.titles = process.env.VUE_APP_TITLE || "默认标题";
    document.title = process.env.VUE_APP_TITLE || "默认标题";
    if (this.hasValidToken) {
      this.user();
      connectLoginStatusSocket(localStorage.getItem("token")); // ★ 加这一行
    }
    if (!this.hasValidToken) {
      this.isLoginDialogOpen = true;
    }
  },

  methods: {
    //解绑对应平台 支持 phone / wechat / douyin / alipay
    async delpt(tet) {
      const sendata = {
        memberId: this.$store.state.frontUserInfo.belongId,
        platform: tet,
      };
      const res = await this.$api.Login.LoGIn.del(sendata);
      if (res.data.code == 200) {
        this.$message.success("解绑成功");
        await this.user();
      } else {
        this.$message.error(res.data.msg);
      }
    },
    // ========= 删除 openPhoneDialog =========
    //打开修改密码弹窗
    openPwdDialog() {
      this.pwdForm.oldPassword = "";
      this.pwdForm.newPassword = "";
      this.pwdDialogVisible = true;
    },
    // ========= 新增：手机号失焦提交 =========
    async submitPhoneBind() {
      const phone = this.bindPhoneVal.trim();
      if (!phone) {
        return this.$message.warning("请输入手机号");
      }
      const sendata = {
        phone: phone,
      };
      const res = await this.$api.Login.LoGIn.updata(sendata);
      if (res.data.code == 200) {
        this.$message.success("手机号绑定成功");
        await this.user();
      } else {
        this.$message.error(res.data.msg);
      }
    },
    //提交密码
    async submitPwd() {
      if (!this.pwdForm.oldPassword || !this.pwdForm.newPassword) {
        return this.$message.warning("旧密码、新密码不能为空");
      }
      this.oldpass = this.pwdForm.oldPassword;
      this.newpass = this.pwdForm.newPassword;
      await this.getpass();
      this.pwdDialogVisible = false;
    },
    //设置手机号
    async getphone() {
      const sendata = {
        phone: this.upphone,
      };
      const res = await this.$api.Login.LoGIn.updata(sendata);
      if (res.data.code == 200) {
        this.$message.success("设置成功");
      } else {
        this.$message.error(res.data.msg);
      }
    },
    //修改密码
    async getpass() {
      const sendata = {
        oldPassword: this.oldpass,
        newPassword: this.newpass,
      };
      const res = await this.$api.Login.LoGIn.uppass(sendata);
      if (res.data.code == 200) {
        this.$message.success("修改密码成功");
      } else {
        this.$message.error(res.data.msg);
      }
    },
    async getsta(sta) {
      const res = await this.$api.Login.LoGIn.get(sta);
      return res;
    },
    clearPollTimer() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
      this.pollCurrentCount = 0;
    },
    startPollBindState(bindState) {
      this.clearPollTimer();
      this.pollCurrentCount = 0;
      this.pollTimer = setInterval(async () => {
        this.pollCurrentCount++;
        if (this.pollCurrentCount >= this.pollMaxCount) {
          this.clearPollTimer();
          this.$message.warning("绑定超时，请重新操作");
          this.iframeAuthVisible = false;
          return;
        }
        try {
          const res = await this.getsta(bindState);
          console.log(res.data.code, "assssssssssssssssssss");
          if (res.data.code == 200) {
            this.clearPollTimer();
            this.$message.success(res.data.data);
            this.iframeAuthVisible = false;
            await this.user();
            this.accountSecurityVisible = true;
          }
        } catch (err) {
          console.debug("绑定轮询中", err);
        }
      }, 2000);
    },
    async bound(tex) {
      const sendata = {
        memberId: this.$store.state.frontUserInfo.belongId,
        platform: tex,
      };
      const res = await this.$api.Login.LoGIn.bdpt(sendata);
      console.log(res.data.code, "aaaaaaaaaaaaaaaaaa");
      if (res.data.code === "200") {
        let authUrl = res.data.data;
        authUrl =
          authUrl + (authUrl.includes("?") ? "&" : "?") + "self_redirect=true";
        const stateMatch = authUrl.match(/state=([^&]+)/);
        const bindState = stateMatch ? stateMatch[1] : "";
        if (!bindState) {
          this.$message.error("获取授权state失败");
          return;
        }
        this.authIframeUrl = authUrl;
        this.iframeAuthVisible = true;
        this.startPollBindState(bindState);
      } else {
        this.$message.warning(res.data.msg || "绑定地址获取失败");
      }
    },
    handleIframeDialogClose() {
      this.clearPollTimer();
      this.authIframeUrl = "";
    },
    getFullImgUrl(url) {
      if (!url) return "";
      if (/^https?:\/\//.test(url)) {
        return url;
      }
      return `https://${url}`;
    },
    async user() {
      try {
        const res = await this.$api.Login.LoGIn.qtuser();
        await this.$store.dispatch("setFrontUserInfo", res.data.data);
        this.version = res.data.data.version || 0;
        this.accountInfo = {
          phone: res.data.data.phone || "",
          wechat: !!res.data.data.wechatBindFlag,
          douyin: !!res.data.data.douyinBindFlag,
          wxname: res.data.data.wechatBindName || "",
          dyname: res.data.data.douyinBindName || "",
          zfbname: res.data.data.alipayBindName || "",
          alipay: !!res.data.data.alipayBindFlag,
        };
      } catch (error) {
        console.error("获取前台用户信息失败：", error);
      }
    },
    handleFrontLogout() {
      this.$store.dispatch("frontLogout").then(() => {
        closeLoginStatusSocket(); // ★ 加这一行
        this.$message.success("退出登录成功！");
        this.isMoreDialogOpen = false;
        this.version = 0;
        this.$router.push({ name: "About" });
      });
    },

    openLoginDialog() {
      this.isLoginDialogOpen = true;
    },
    async handleLoginSuccess(data) {
      const { token, userInfo } = data;
      await this.$store.dispatch("frontLogin", token);
      connectLoginStatusSocket(token); // ★ 加这一行
      if (userInfo) {
        await this.$store.dispatch("setFrontUserInfo", userInfo);
        this.version = userInfo.version || 0;
        sessionStorage.setItem("web_username", userInfo.nickName);
      } else {
        await this.user();
      }
    },
    handleAuthMenuClick(e) {
      if (!this.hasValidToken) {
        e.stopImmediatePropagation();
        e.preventDefault();
        this.isLoginDialogOpen = true;
        this.$nextTick(() => {
          const menuEl = this.$el.querySelector(".el-menu");
          if (menuEl && menuEl.__vue__) {
            menuEl.__vue__.activeIndex = "/about";
          }
        });
      }
    },
    openPublishPage() {
      const publishUrl = this.$router.resolve({
        name: "indexinfo",
      }).href;
      window.open(publishUrl, "_blank");
    },
    profile() {
      const publishUrl = this.$router.resolve({
        name: "profile",
      }).href;
      window.open(publishUrl, "_blank");
    },
    openAccountSecurityDialog() {
      this.isMoreDialogOpen = false;
      this.accountSecurityVisible = true;
    },
  },
};
</script>
<style scoped lang="less">
@import "../layouts/admin/FrontLayout.scss";
.dis {
  display: flex;
  height: 90px !important;
}
.imgs {
  width: 45px !important;
  height: 45px !important;
  margin-top: 25px !important;
}
.top-right-publish {
  position: fixed;
  top: 20px;
  right: 30px;
  z-index: 1000;
}
</style>
<style>
.login-menu-item,
.login-menu-item:hover {
  background-color: #f8b42e !important;
  color: black !important;
}
.publish-btn {
  background-color: #ffae00 !important;
  border-color: #ffae00 !important;
  color: #333 !important;
  font-weight: 500;
}
.publish-btn-disabled {
  background-color: #e6e6e6 !important;
  border-color: #e6e6e6 !important;
  color: #999 !important;
  cursor: not-allowed !important;
  opacity: 1 !important;
}
.security-btn {
  padding: 10px 16px;
  font-size: 16px;
  cursor: pointer;
}
.security-btn:hover {
  background-color: #f5f5f5;
}
.logout-btn {
  padding: 10px 16px;
  font-size: 16px;
  cursor: pointer;
  color: #f56c6c;
}
.logout-btn:hover {
  background-color: #f5f5f5;
}
/* -------- 下面是新增分组卡片样式，完全不碰DOM结构，纯css分组 -------- */
.el-dialog__body {
  padding-top: 10px !important;
}
.security-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 12px;
  font-size: 18px;
  border-bottom: 1px solid #eee;
  margin: 0 4px;
}
.security-item:last-child {
  border-bottom: none;
}
.security-item .value {
  color: #666;
}
/* 第一组：手机号、登录密码 包裹为圆角卡片 */
.security-item:nth-child(1),
.security-item:nth-child(2) {
  background: #f7f7f7;
}
.security-item:nth-child(1) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.security-item:nth-child(2) {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  border-bottom: 0;
  margin-bottom: 69px;
}
/* 第二组：微信、抖音、支付宝 包裹为圆角卡片 */
.security-item:nth-child(3),
.security-item:nth-child(4),
.security-item:nth-child(5) {
  background: #f7f7f7;
}
.security-item:nth-child(3) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.security-item:nth-child(5) {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  border-bottom: 0;
  margin-bottom: 200px;
}

.about-btn:hover,
.more-btn:hover {
  color: black;
}
</style>
